import { render, staticRenderFns } from "./tableReminder.vue?vue&type=template&id=fb13087a&"
import script from "./tableReminder.vue?vue&type=script&lang=js&"
export * from "./tableReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports